import { ChangeDetectionStrategy, Component, input, InputSignal, output, OutputEmitterRef } from '@angular/core';
import { SzSegmentedComponent } from '../sz-segmented/sz-segmented.component';
import { SzSegmentedOption } from '../sz-segmented/sz-segmented-option.type';

@Component({
  selector: 'sz-range-filter',
  templateUrl: './sz-range-filter.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [SzSegmentedComponent]
})
export class SzRangeFilterComponent {
  readonly value: InputSignal<number> = input.required<number>();
  readonly options: InputSignal<ReadonlyArray<SzSegmentedOption<number>>> =
    input.required<ReadonlyArray<SzSegmentedOption<number>>>();

  readonly valueChange: OutputEmitterRef<number> = output<number>();
}
